
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1402Dialog extends Serenity.EntityDialog<Report_1402Row, any> {
        protected getFormKey() { return Report_1402Form.formKey; }
        protected getIdProperty() { return Report_1402Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1402Row.localTextPrefix; }
        protected getNameProperty() { return Report_1402Row.nameProperty; }
        protected getService() { return Report_1402Service.baseUrl; }
        protected getDeletePermission() { return Report_1402Row.deletePermission; }
        protected getInsertPermission() { return Report_1402Row.insertPermission; }
        protected getUpdatePermission() { return Report_1402Row.updatePermission; }

        protected form = new Report_1402Form(this.idPrefix);

    }
}